import React from 'react';
import { FieldArray } from 'redux-form';
import { FormDataConsumer } from 'react-admin';

import Slots from './Slots';

type Props = {
  dispatch: any,
  record: any,
  syncErrors: any
};

const SlotsTab = (props: Props) => (
  <div>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && !formData.bordeaux &&
        <div style={{ padding: 10 }}>You can only edit these settings if the placement is set to bordeaux</div>
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.bordeaux &&
        <div style={{ padding: 10 }}>
          <FieldArray
            addItemLabel="Add Slot"
            component={Slots}
            dispatch={props.dispatch}
            mainLabel="Slots"
            name="slots"
            record={props.record}
            syncErrors={props.syncErrors} />
        </div>
      }
    </FormDataConsumer>
  </div>
);

export default SlotsTab;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/SlotsTab.tsx